exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nimg { border-radius: 50%;\n}\n.custom-select {\n  position: relative;\n  font-family: Arial,serif;\n  background-color: white;\n  appearance: auto;\n  border: 2px solid #333333;\n}\n", ""]);

// exports
